/* Kidslar native pages (GemPages replacement): lazy video autoplay, carousels, countdowns, dialogs, scroll links.
   Add to cart buttons reuse the PDP kit (assets/k-pdp.js, data-kp-atc). */
(function () {
  if (window.__kqInit) return; window.__kqInit = true;
  // Videos: nothing downloads until near the viewport; hidden phone/desktop twins never load.
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload !== 'auto') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }, { rootMargin: '300px 0px' }) : null;
  function initVideos() {
    document.querySelectorAll('video[data-kq-autoplay]:not([data-kq-v])').forEach(function (v) {
      v.setAttribute('data-kq-v', ''); v.muted = true;
      if (vio) vio.observe(v); else { v.preload = 'auto'; v.play(); }
    });
  }
  // Carousels: native scroll-snap track + arrows/dots + optional autoplay.
  function initCarousel(root) {
    if (root.__kq) return; root.__kq = true;
    var track = root.querySelector('.kq-car__track'); if (!track) return;
    var prev = root.querySelector('[data-kq-prev]'), next = root.querySelector('[data-kq-next]'), dots = root.querySelector('.kq-car__dots');
    var vert = getComputedStyle(track).flexDirection === 'column';
    var slides = [].slice.call(track.children);
    function step() { if (!slides[0]) return 1; var r = slides[0].getBoundingClientRect(), g = parseFloat(getComputedStyle(track).gap) || 0; return (vert ? r.height : r.width) + g; }
    function idx() { return Math.round((vert ? track.scrollTop : track.scrollLeft) / Math.max(1, step())); }
    function pages() { var per = Math.max(1, Math.round((vert ? track.clientHeight : track.clientWidth) / Math.max(1, step()))); return Math.max(1, slides.length - per + 1); }
    function go(i) { var n = pages(); if (root.dataset.kqLoop) i = (i + n) % n; i = Math.max(0, Math.min(n - 1, i)); track.scrollTo(vert ? { top: i * step(), behavior: 'smooth' } : { left: i * step(), behavior: 'smooth' }); }
    function mark() {
      var i = idx(), n = pages();
      if (prev && !root.dataset.kqLoop) prev.disabled = i <= 0;
      if (next && !root.dataset.kqLoop) next.disabled = i >= n - 1;
      if (dots) {
        if (dots.children.length !== n) { dots.innerHTML = ''; for (var k = 0; k < n; k++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (k + 1) + '. slayt'); b.dataset.i = k; dots.appendChild(b); } }
        [].forEach.call(dots.children, function (b, k) { b.setAttribute('aria-current', String(k === i)); });
      }
    }
    root.__kqGo = go;
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(+b.dataset.i); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', mark);
    var ms = +root.dataset.kqAuto;
    if (ms > 0) { var t = setInterval(function () { if (!document.hidden && root.getClientRects().length) go(idx() + 1 >= pages() ? 0 : idx() + 1); }, ms); root.addEventListener('pointerdown', function () { clearInterval(t); }, { once: true }); }
    mark();
  }
  // Countdown: data-kq-cd = "evergreen:<seconds>" (restarts per visitor, stored in localStorage) or "date:<ISO>"
  function initCountdown(root) {
    if (root.__kq) return; root.__kq = true;
    var spec = root.dataset.kqCd || '', end = 0, key = 'kq-cd-' + (root.dataset.kqCdKey || location.pathname);
    if (spec.indexOf('evergreen:') === 0) {
      var len = +spec.slice(10) * 1000, saved = 0;
      try { saved = +localStorage.getItem(key) || 0; } catch (e) {}
      if (!saved || saved < Date.now()) { saved = Date.now() + len; try { localStorage.setItem(key, saved); } catch (e) {} }
      end = saved;
    } else if (spec.indexOf('date:') === 0) end = Date.parse(spec.slice(5));
    function nextDaily() { var p = spec.split(':'), t = new Date(); t.setHours(+p[1], +p[2], 0, 0); if (t.getTime() <= Date.now()) t.setDate(t.getDate() + 1); return t.getTime(); }
    if (spec.indexOf('daily:') === 0) end = nextDaily();
    var f = { d: root.querySelector('[data-kq-d]'), h: root.querySelector('[data-kq-h]'), m: root.querySelector('[data-kq-m]'), s: root.querySelector('[data-kq-s]') };
    ['d', 'h', 'm', 's'].forEach(function (k) { var e = f[k]; if (e) { while (e.firstElementChild && !/\d/.test([].map.call(e.childNodes, function (c) { return c.nodeType === 3 ? c.textContent : ''; }).join(''))) e = e.firstElementChild; f[k] = e; } });
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, end - Date.now()), s = Math.floor(left / 1000);
      if (f.d) f.d.textContent = pad(Math.floor(s / 86400));
      if (f.h) f.h.textContent = pad(Math.floor(s % 86400 / 3600) + (f.d ? 0 : Math.floor(s / 86400) * 24));
      if (f.m) f.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (f.s) f.s.textContent = pad(s % 60);
      if (left <= 0 && spec.indexOf('daily:') === 0) end = nextDaily();
      if (left <= 0 && root.dataset.kqCdLoop && spec.indexOf('evergreen:') === 0) { end = Date.now() + (+spec.slice(10) * 1000); try { localStorage.setItem(key, end); } catch (e) {} }
    }
    tick(); setInterval(tick, 1000);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (a) {
      var h = a.getAttribute('href');
      if (h === '#scroll-to-top' || h === '#kq-top') { e.preventDefault(); var t = document.querySelector('[data-kq-top]') || document.querySelector('.kp-main'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); else window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if (h && h.length > 1 && h.charAt(0) === '#' && h.indexOf('#kp-') !== 0) {
        var dlg = document.getElementById(h.slice(1));
        if (dlg && dlg.tagName === 'DIALOG') { e.preventDefault(); if (dlg.showModal) dlg.showModal(); return; }
        var all = document.querySelectorAll('[id="' + h.slice(1).replace(/"/g, '') + '"]'), tg = null;
        for (var i = 0; i < all.length; i++) if (all[i].getClientRects().length) { tg = all[i]; break; }
        if (tg) { e.preventDefault(); tg.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      }
    }
    var bn = e.target.closest('[data-kq-buynow]');
    if (bn) {
      e.preventDefault();
      var form = document.getElementById(bn.dataset.kpForm);
      if (!form || bn.getAttribute('aria-busy') === 'true') return;
      var fd = new FormData(form), act = form.getAttribute('action') || '', qi = act.indexOf('?');
      if (qi > -1) new URLSearchParams(act.slice(qi + 1)).forEach(function (v, k) { if (!fd.has(k)) fd.append(k, v); });
      bn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.status && d.status !== 200) { alert(d.description || d.message || 'Sepete eklenemedi'); bn.removeAttribute('aria-busy'); return; } window.location.href = '/checkout'; })
        .catch(function () { form.submit(); });
      return;
    }
    var tb = e.target.closest('[data-kq-tab]');
    if (tb) {
      var root = tb.closest('[data-kq-tabs]'), k = tb.dataset.kqTab, cur = root.querySelector('[data-kq-tab][aria-selected="true"]');
      if (cur && cur !== tb) { var c1 = cur.className; cur.className = tb.className; tb.className = c1; cur.setAttribute('aria-selected', 'false'); }
      tb.setAttribute('aria-selected', 'true');
      root.querySelectorAll('[data-kq-panel]').forEach(function (p) { if (p.closest('[data-kq-tabs]') === root) p.hidden = p.dataset.kqPanel !== k; });
      root.querySelectorAll('.kq-car').forEach(function (c) { c.dispatchEvent(new Event('kq:show')); });
      window.dispatchEvent(new Event('resize'));
      return;
    }
    var th = e.target.closest('[data-kq-thumbs] [data-kq-goto]');
    if (th) {
      var grp = th.closest('[data-kq-thumbs]').dataset.kqGroup, mains = document.querySelectorAll('[data-kq-main][data-kq-group="' + grp + '"]');
      for (var m = 0; m < mains.length; m++) if (mains[m].getClientRects().length && mains[m].__kqGo) { mains[m].__kqGo(+th.dataset.kqGoto); break; }
      [].forEach.call(th.parentNode.children, function (x) { x.toggleAttribute('data-kq-active', x === th); });
      return;
    }
    var o = e.target.closest('[data-kq-open]');
    if (o) { e.preventDefault(); var d = document.getElementById(o.dataset.kqOpen); if (d && d.showModal) d.showModal(); return; }
    if (e.target.closest('[data-kq-close]')) { var dd = e.target.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('kq-dlg')) e.target.close();
  });
  function boot() { initVideos(); document.querySelectorAll('.kq-car').forEach(initCarousel); document.querySelectorAll('[data-kq-cd]').forEach(initCountdown); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
